import $ from 'jquery';
import moment from 'moment';

import "./less/skins/skin-uniselect.less"

global['moment'] = moment;
global.$ = global.jQuery = $;

global.$msg = {};
global.$msgloaded = false;
$.getJSON( "/message-source.json", function( data ) {
	global.$msg = data;
	global.$msgloaded = true;
	$.each(data, function(key, value){
		global.localStorage.setItem(key, value);
	});
	global.localStorage.$msgloaded = true;
	});

global.resolveMsg = function( code ){
	if(global.localStorage.$msgloaded){
		return global.localStorage.getItem(code);
	}
	var control = Date.now();
	while(!global.$msgloaded){
		var timeout = Date.now();
		if(timeout - control > 10000){
			return code;
		}
	}
	return global.resolveMsg( code );
}
//Blocks element in the UI
global.blockElement = function(element) {
	$(element).wrap('<div blockerwrapper="true" class="overlay-wrapper" style="position:relative"></div>');
	$(element).after('<div blocker="true" class="overlay" style="background-color:rgba(255, 255, 255, 0);"></div>');
}

//Unblocks element in the UI
global.unblockElement = function(element) {
	if( $(element).next().attr('blocker') == "true" 
		&& $(element).parent().attr('blockerwrapper') == 'true') {
		$(element).next().remove();
		$(element).unwrap();
	}
}

function getQueryString() {
    var result = {};
    if(!global.location.search.length) return result;
    var qs = global.location.search.slice(1);
    var parts = qs.split("&");
    for(var i=0, len=parts.length; i<len; i++) {
        var tokens = parts[i].split("=");
        result[tokens[0]] = decodeURIComponent(tokens[1]);
    }
    return result;
}

$(document).ready(function() {
    $("#language").submit(function(e) {
        //var that = this;
        var qs = getQueryString();
        for(var key in qs) {
            var field = $(document.createElement("input"));
            field.attr("name", key).attr("type","hidden");
            field.val(qs[key]);
            $(this).append(field);
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets-src/main.js
// module id = 105
// module chunks = 1